import { EditActionIcon } from '@common';
import { Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type TaskDetailsModalTitlePropsType = {
  mode: 'display' | 'edit';
  title: string;
  canEdit: boolean;
  onEdit: () => void;
};

export const TaskDetailsModalTitle: React.FC<TaskDetailsModalTitlePropsType> = ({
  mode,
  title,
  canEdit,
  onEdit,
}) => {
  const { t } = useTranslation('tasks');

  return (
    <Group justify="space-between" wrap="nowrap" gap="sm" pr="xs" w="100%">
      <Text fw={700} lineClamp={1}>
        {mode === 'edit' ? t('EDIT.TITLE') : title}
      </Text>
      {canEdit && mode === 'display' ? (
        <EditActionIcon onClick={onEdit} />
      ) : null}
    </Group>
  );
};
